module.exports = __webpack_public_path__ + "img/2.bdf14988.jpg";